import { Typography, Tabs, Tab } from '@mui/material'

import { Fragment, useMemo } from 'react'

import { useNavigate, useParams } from 'react-router-dom'
import { generateUrl } from '@services/routes'
import { ROUTE_LANDING_ZONES_ID_MODE } from '@features/routes'

import { AWS, AZURE, useLandingZones } from '@features/hooks/LandingZones'

import { usePageTracking } from '@services/hooks/useGoogleAnalytics'
import { PAGE_TRACKING_DATA, GA_CONFIG } from '@features/config/analytics'
import { tplRender } from '@services/utils'

import Breadcrumbs from '@components/Breadcrumbs'

import Tags from '@views/Landingzones/Detail/Tags'
import Groups from '@views/Landingzones/Detail/Groups'
import Services from '@views/Landingzones/Detail/Services'
import Teams from '@views/Landingzones/Detail/Teams'

const TAB_MODES = ['groups', 'service-principals', 'tags', 'teams']
const TAB_COMPONENTS = [Groups, Services, Tags, Teams]

export const Detail = () => {
    const { id, mode } = useParams()
    const navigate = useNavigate()

    const { getProvider } = useLandingZones()

    const tabValue = useMemo(() => {
        const index = TAB_MODES.indexOf(mode?.toLowerCase())
        return index >= 0 ? index : 0
    }, [mode])

    usePageTracking({
        ...GA_CONFIG.default_data,
        // eslint-disable-next-line
        page_name: tplRender(PAGE_TRACKING_DATA.lz.details.page_name, {lzName: id}),
        // eslint-disable-next-line
        page_url: tplRender(PAGE_TRACKING_DATA.lz.details.page_url, {lzName: id})
    })

    const handleTabChange = (event, value) => {
        if (!id) return
        navigate(generateUrl(ROUTE_LANDING_ZONES_ID_MODE, {
            id: id, mode: TAB_MODES[value]
        }))
    }

    const TabPanel = TAB_COMPONENTS[tabValue]
    const provider = getProvider(id)

    return (
        <Fragment>
            <Breadcrumbs
                routes={[
                    {label: 'Home', link: '/#/home'},
                    {label: 'Landing-zones', link: '/#/landing-zones'},
                    {label: id ?? '-'}
                ]}
            />

            <Typography variant="h2" sx={{mt: 1, mb: 3}}>
                {id ?? '-'}
            </Typography>

            {(provider === AZURE) && (
                <Tabs value={tabValue} onChange={handleTabChange} sx={{mb: 2, width: '415px'}}>
                    <Tab label="Groups" />
                    <Tab label="Service principals"/>
                    <Tab label="Tags"/>
                    <Tab label="Teams"/>
                </Tabs>
            )}

            {(provider === AWS) && (
                <Tabs value={tabValue} onChange={handleTabChange} sx={{mb: 2, width: '242px'}}>
                    <Tab label="Groups" />
                    <Tab label="Service principals"/>
                </Tabs>
            )}

            {id && <TabPanel id={id} />}
        </Fragment>
    )
}

export default Detail